var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBricksLeftBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 125,
    viewBox: "0 0 138 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9734 45.3715L50.7637 9.95706C50.8242 7.48123 51.8569 5.12772 53.6401 3.40311C55.4089 1.68751 57.7793 0.726453 60.2473 0.724609H128.087C130.602 0.724609 133.015 1.7212 134.793 3.49388C136.572 5.26656 137.571 7.67012 137.571 10.1771V45.5607C137.577 48.0623 136.588 50.4647 134.821 52.2408C133.937 53.1225 132.887 53.8219 131.731 54.2977C130.576 54.7736 129.337 55.0162 128.087 55.0131H59.457C58.1959 55.0117 56.9485 54.7552 55.7903 54.2577C54.6101 53.7775 53.5361 53.0705 52.6291 52.1777C51.7485 51.2679 51.0505 50.1984 50.5738 49.0269C50.1385 47.8587 49.9347 46.617 49.9734 45.3715Z",
    fill: "#6A82FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9083 69.2021H9.45985C6.95094 69.2021 4.54474 70.2036 2.77067 71.9876C0.996605 73.7716 0 76.192 0 78.715V115.212C0 117.735 0.996605 120.154 2.77067 121.938C4.54474 123.722 6.95094 124.725 9.45985 124.725H76.9083C78.1554 124.728 79.3908 124.482 80.5435 124.003C81.6962 123.524 82.7431 122.822 83.6244 121.934C85.3874 120.147 86.3743 117.729 86.3681 115.212V78.715C86.3681 76.192 85.3715 73.7716 83.5975 71.9876C81.8234 70.2036 79.4172 69.2021 76.9083 69.2021Z",
    fill: "#6A82FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBricksLeftBottom);
export default __webpack_public_path__ + "static/media/bricks_left_bottom.c19361bf9983c2cd496cb18133599f8e.svg";
export { ForwardRef as ReactComponent };